var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInvestmentsStockIndex(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-5026.000000, -1641.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Investments/Stock-index",
    transform: "translate(5026.000000, 1641.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32,14.999625 L32,26.999925 C32,28.6579664 30.6569748,30 28.9999437,30 L28.9999437,30 L11.999625,30 L11.999625,18.999725 L18.9997562,18.999725 C21.4148015,18.999725 23.4348394,17.279682 23.8978481,14.999625 L23.8978481,14.999625 L32,14.999625 Z M10.0001875,19.000525 L10.0001875,29.000775 C8.49415927,29.000775 7.27213635,27.7787445 7.27213635,26.2727068 L7.27213635,23.6566414 L2.3680444,28.5637641 L0.439008231,26.6357159 L5.3441002,21.7275932 L2.72705113,21.7275932 C1.22002288,21.7275932 0,20.5055626 0,19.000525 L10.0001875,19.000525 Z M25.7208823,18.4277107 L23.8168466,18.4287107 L23.8168466,24.1698542 L22.0768139,22.4298107 C21.3338,21.6867922 20.1287774,21.6867922 19.3847635,22.4298107 L19.3847635,22.4298107 L24.7698644,27.8139453 L30.1529654,22.4298107 C29.4099514,21.6867922 28.2039288,21.6867922 27.4609149,22.4298107 L27.4609149,22.4298107 L25.7208823,24.1698542 L25.7208823,18.4277107 Z M22.0001125,2 L22.0001125,14.0003 C22.0001125,15.6563414 20.6570873,17.000375 19.0000563,17.000375 L19.0000563,17.000375 L1.9997375,17.000375 L1.9997375,5.000075 C1.9997375,3.34303358 3.34276268,2 4.99979375,2 L4.99979375,2 L22.0001125,2 Z M14.3839697,5.4760869 L8.99986875,10.8602215 C9.74288268,11.6032401 10.9479053,11.6032401 11.6919192,10.8602215 L11.6919192,10.8602215 L13.4319518,9.120178 L13.4319518,14.8613215 L15.3359875,14.8613215 L15.3359875,9.120178 L17.0760202,10.8602215 C17.8190341,11.6032401 19.0240567,11.6032401 19.7670706,10.8602215 L19.7670706,10.8602215 L14.3839697,5.4760869 Z",
    id: 15
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvestmentsStockIndex);
export default __webpack_public_path__ + "static/media/investments-stock-index.98c7a4bb.svg";
export { ForwardRef as ReactComponent };